export const DateFormats = {
  1: 'YYYY-MM-DD',
  2: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  3: 'DD MMM YYYY',
  4: 'DD MMM YYYY HH:mm',
  5: 'DD MMMM YYYY',
};
